import { FootballLeague } from '@/types';

export const FOOTBALL_LEAGUES: FootballLeague[] = [
  { id: '1',   name: 'Copa do Mundo',        country: 'World',      logo: 'https://media.api-sports.io/football/leagues/1.png',   flag: '🌍' },
  { id: '39',  name: 'Premier League',       country: 'England',    logo: 'https://media.api-sports.io/football/leagues/39.png',  flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
  { id: '140', name: 'La Liga',              country: 'Spain',      logo: 'https://media.api-sports.io/football/leagues/140.png', flag: '🇪🇸' },
  { id: '135', name: 'Serie A',              country: 'Italy',      logo: 'https://media.api-sports.io/football/leagues/135.png', flag: '🇮🇹' },
  { id: '78',  name: 'Bundesliga',           country: 'Germany',    logo: 'https://media.api-sports.io/football/leagues/78.png',  flag: '🇩🇪' },
  { id: '61',  name: 'Ligue 1',              country: 'France',     logo: 'https://media.api-sports.io/football/leagues/61.png',  flag: '🇫🇷' },
  { id: '2',   name: 'Champions League',     country: 'Europe',     logo: 'https://media.api-sports.io/football/leagues/2.png',   flag: '🇪🇺' },
  { id: '3',   name: 'Europa League',        country: 'Europe',     logo: 'https://media.api-sports.io/football/leagues/3.png',   flag: '🇪🇺' },
  { id: '71',  name: 'Brasileirão Série A',  country: 'Brazil',     logo: 'https://media.api-sports.io/football/leagues/71.png',  flag: '🇧🇷' },
  { id: '73',  name: 'Copa do Brasil',       country: 'Brazil',     logo: 'https://media.api-sports.io/football/leagues/73.png',  flag: '🇧🇷' },
  { id: '128', name: 'Copa Libertadores',    country: 'S. America', logo: 'https://media.api-sports.io/football/leagues/128.png', flag: '🌎' },
];

export const NFL_DIVISIONS = {
  AFC: {
    North: ['Baltimore Ravens', 'Cincinnati Bengals', 'Cleveland Browns', 'Pittsburgh Steelers'],
    South: ['Houston Texans', 'Indianapolis Colts', 'Jacksonville Jaguars', 'Tennessee Titans'],
    East:  ['Buffalo Bills', 'Miami Dolphins', 'New England Patriots', 'New York Jets'],
    West:  ['Denver Broncos', 'Kansas City Chiefs', 'Las Vegas Raiders', 'Los Angeles Chargers'],
  },
  NFC: {
    North: ['Chicago Bears', 'Detroit Lions', 'Green Bay Packers', 'Minnesota Vikings'],
    South: ['Atlanta Falcons', 'Carolina Panthers', 'New Orleans Saints', 'Tampa Bay Buccaneers'],
    East:  ['Dallas Cowboys', 'New York Giants', 'Philadelphia Eagles', 'Washington Commanders'],
    West:  ['Arizona Cardinals', 'Los Angeles Rams', 'San Francisco 49ers', 'Seattle Seahawks'],
  },
};

export const NBA_CONFERENCES = {
  East: [
    'Boston Celtics', 'Brooklyn Nets', 'New York Knicks', 'Philadelphia 76ers', 'Toronto Raptors',
    'Chicago Bulls', 'Cleveland Cavaliers', 'Detroit Pistons', 'Indiana Pacers', 'Milwaukee Bucks',
    'Atlanta Hawks', 'Charlotte Hornets', 'Miami Heat', 'Orlando Magic', 'Washington Wizards',
  ],
  West: [
    'Denver Nuggets', 'Minnesota Timberwolves', 'Oklahoma City Thunder', 'Portland Trail Blazers', 'Utah Jazz',
    'Golden State Warriors', 'LA Clippers', 'Los Angeles Lakers', 'Phoenix Suns', 'Sacramento Kings',
    'Dallas Mavericks', 'Houston Rockets', 'Memphis Grizzlies', 'New Orleans Pelicans', 'San Antonio Spurs',
  ],
};

export const LEAGUE_REFRESH_INTERVALS = {
  live: 30_000,    // 30s quando há jogo ao vivo
  idle: 300_000,   // 5min sem jogos ao vivo
  scheduled: 60_000, // 1min para verificar início
};
